<template>
  <div>
    <el-card style="min-height: 45rem">
      <div class="flex-def flex-zCenter flex-cCenter flex-zTopBottom">
        <el-form label-position="left" style="width: 26rem">
          <div style="width: 100%;padding: 1rem 0 2rem;font-weight: 600">团队管理奖励规则配置</div>
          <el-form-item label="计算模式">
            <el-radio-group v-model="form.award_mode">
              <el-radio :label="1">直接计算</el-radio>
              <el-radio :label="2">极差模式</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item align="right">
            <el-button @click="edit" type="primary">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "conf",
  components:{
  },
  data() {
    return {
      form:{
        award_mode:1,
      }
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$u.api.shop.plugin.teamManage.rule().then(res=>{
        this.form = res;
      })
    },
    edit(){
      this.$u.api.shop.plugin.teamManage.ruleEdit(this.form).then(()=>{
        this.$message.success("操作成功");
        this.load();
      })
    },
  }
}
</script>

<style scoped>

</style>